import { Modal, ModalHeader, ModalBody, Spinner } from 'reactstrap';
import { useEffect, useState } from 'react';
import { callApi } from '../../ApiHelper/ApiHelper';
import { apiUrl } from '../../ApiHelper/ApiUrl';
import { useForm, Controller } from 'react-hook-form';
import { DatePicker } from "rsuite";
import ErrorMessage from '../../components/comman/ErrorMessage';
import { toast } from "react-toastify";
import moment from 'moment';
import MultiSelectDropdown from '../../components/comman/MultiSelectDropdown';

const CreateMeetingModal = ({ isOpen, toggle, selectedMeeting, getMeetingList }) => {

    const [pageStates, setPageStates] = useState({
        users: [],
        selectedUsers: [],
        sites: [],
        selectedSites: [],
        isLoadingSites: false,
        isLoadingUsers: false,
        isLoadingSubmit: false,
    });

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setValue,
        control,
    } = useForm({ mode: "onBlur" });

    const resetForm = () => {
        reset();
        setPageStates((prev) => ({
            ...prev,
            users: [],
            selectedUsers: [],
            sites: [],
            selectedSites: [],
            isLoadingUsers: false,
            isLoadingSubmit: false,
            isLoadingSites: false,
        }));
    };

    useEffect(() => {
        if (isOpen) {
            if (selectedMeeting) {
                setValue("title", selectedMeeting?.title);
                setValue("agenda", selectedMeeting?.agenda);
                if (selectedMeeting?.date) {
                    setValue("date", moment(selectedMeeting?.date).format("YYYY-MM-DD"));
                }
                if (selectedMeeting?.joinees) {
                    setValue("attendees", selectedMeeting?.joinees?.map((item) => ({
                        value: item?.id,
                        label: item?.name,
                        id: item?.id,
                        name: item?.name,
                    })));
                    setPageStates((prev) => ({
                        ...prev,
                        selectedUsers: selectedMeeting?.joinees?.map((item) => ({
                            value: item?.id,
                            label: item?.name,
                            id: item?.id,
                            name: item?.name,
                        }))
                    }));
                }
                if (selectedMeeting?.sites) {
                    setValue("sites", selectedMeeting?.sites?.map((item) => ({
                        value: item?.id,
                        label: item?.name,
                        id: item?.id,
                        name: item?.name,
                    })));
                    setPageStates((prev) => ({
                        ...prev,
                        selectedSites: selectedMeeting?.sites?.map((item) => ({
                            value: item?.id,
                            label: item?.name,
                            id: item?.id,
                            name: item?.name,
                        }))
                    }));
                }
                GetUsersList();
                GetSitesList();
            } else {
                resetForm();
                GetUsersList();
                GetSitesList();
            }
        }
    }, [isOpen, selectedMeeting]);

    const handleUserChange = (selectedValues) => {
        setValue("attendees", selectedValues, { shouldValidate: true });
        setPageStates((prevStates) => ({
            ...prevStates,
            selectedUsers: selectedValues,
        }));
    };

    const handleSiteChange = (selectedValues) => {
        setValue("sites", selectedValues, { shouldValidate: true });
        setPageStates((prevStates) => ({
            ...prevStates,
            selectedSites: selectedValues,
        }));
    };

    const GetUsersList = (search) => {
        setPageStates((prevStates) => ({
            ...prevStates,
            users: [],
        }));
        let options = {
            method: "GET",
        };
        let API = apiUrl.get_employee + `?pageNumber=1&pageSize=10&status=current${search ? `&search=${search}` : ""}`;
        setPageStates((prevStates) => ({ ...prevStates, isLoadingUsers: true }));
        callApi(API, options).then((response) => {
            setPageStates((prevStates) => ({ ...prevStates, isLoadingUsers: false }));
            if (response?.status === true) {
                const formattedData = response?.data?.user.map((item) => ({
                    value: item.id,
                    label: item.name,
                    id: item.id,
                    name: item.name,
                }));
                setPageStates((prevStates) => ({
                    ...prevStates,
                    users: formattedData,
                }));
            } else {
                toast.error(response?.message);
            }
        });
    }

    const GetSitesList = (search) => {
        setPageStates((prevStates) => ({ ...prevStates, isLoadingSites: true }));
        let API = apiUrl.get_site + `?pageNumber=1&pageSize=10${search ? `&search=${search}` : ""}`;
        let options = {
            method: "GET",
        };

        callApi(API, options).then((response) => {
            setPageStates((prevStates) => ({
                ...prevStates,
                sites: response?.data
                    ? response?.data?.site
                        ? response?.data?.site?.map((item) => ({
                            value: item?.id,
                            label: item?.name,
                            ...item,
                        }))
                        : []
                    : [],
            }));
            setPageStates((prevStates) => ({
                ...prevStates,
                isLoadingSites: false,
            }));

        });
    }

    const onSubmit = (data) => {
        const joineeIds = data.attendees ? data.attendees.map(u => u.id !== undefined ? u.id : u.value) : [];
        const siteIds = data.sites ? data.sites.map(u => u.id !== undefined ? u.id : u.value) : [];
        if (joineeIds.length === 0) {
            toast.error("Please select at least one attendee");
            return;
        }


        const submitData = {
            ...(selectedMeeting && { "meetingId": selectedMeeting?.id }),
            "title": data.title,
            "agenda": data.agenda,
            "date": data.date,
            ...(siteIds.length > 0 && { "siteId": JSON.stringify(siteIds) }),
            "joineeIds": JSON.stringify(joineeIds),
        }

        const options = {
            method: selectedMeeting ? "POST" : "POST",
            data: submitData,
        };
        const API = selectedMeeting ? apiUrl.update_meeting : apiUrl.create_meeting;
        setPageStates((prevStates) => ({ ...prevStates, isLoadingSubmit: true }));
        callApi(API, options).then((response) => {
            setPageStates((prevStates) => ({ ...prevStates, isLoadingSubmit: false }));
            if (response?.status === true) {
                toast.success(response.message);
                resetForm();
                getMeetingList();
                toggle();
            } else {
                toast.error(response.message);
            }
        });

    };

    return (
        <Modal isOpen={isOpen} scrollable toggle={toggle} centered size="lg" className="border-0 shadow-lg meeting-modal" contentClassName="border-0 rounded-4">
            <ModalHeader toggle={toggle} className="border-0 pb-2 pt-3 px-3 bg-light rounded-top-4">
                <div className="d-flex align-items-center gap-3">
                    <div className="bg-white p-2 rounded-circle shadow-sm border d-flex align-items-center justify-content-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#257FFD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line></svg>
                    </div>
                    <div>
                        <span className="fs-5 fw-bolder mb-0 text-dark d-block" style={{ letterSpacing: "-0.5px" }}>{selectedMeeting ? "Update Meeting" : "Create New Meeting"}</span>
                        <span className="text-muted fw-medium" style={{ fontSize: "12px" }}>{selectedMeeting ? "Modify existing meeting details" : "Schedule a new meeting and invite participants"}</span>
                    </div>
                </div>
            </ModalHeader>
            <ModalBody className="p-3" style={{ backgroundColor: '#f8fafc' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="bg-white p-3 rounded-4 shadow-sm border-0 mb-3">
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-semibold text-dark mb-1" style={{ fontSize: "12px" }}>
                                    Meeting Title <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control px-2 py-1 shadow-sm"
                                    placeholder="Enter meeting title"
                                    style={{ borderRadius: '8px', border: '1px solid #e2e8f0', color: '#475569', fontSize: "13px", backgroundColor: '#f8fafc' }}
                                    {...register("title", {
                                        required: "This field is required",
                                    })}
                                />
                                <ErrorMessage message={errors.title?.message} />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-semibold text-dark mb-1" style={{ fontSize: "12px" }}>
                                    Date <span className="text-danger">*</span>
                                </label>
                                <Controller
                                    name="date"
                                    control={control}
                                    rules={{
                                        required: "This field is required",
                                        validate: (value) => {
                                            const checkDate = moment(value).startOf('day');
                                            const today = moment().startOf('day');
                                            if (checkDate.isBefore(today)) {
                                                return "Past dates are not allowed for meetings";
                                            }
                                            return true;
                                        }
                                    }}
                                    defaultValue={moment().format("YYYY-MM-DD")}
                                    render={({ field }) => (
                                        <DatePicker size="sm"
                                            {...field}
                                            id="date"
                                            format="dd/MM/yyyy"
                                            oneTap
                                            placeholder="dd/mm/yyyy"
                                            style={{ width: "100%" }}
                                            value={field.value ? new Date(field.value) : null}
                                            onChange={(date) => {
                                                field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                                            }}
                                            shouldDisableDate={(date) => date < new Date(moment().startOf('day'))}
                                            container={() => document.querySelector('.meeting-modal .modal-content') || document.body}
                                            cleanable={false}
                                        />
                                    )}
                                />
                                <ErrorMessage message={errors.date?.message} />
                            </div>
                            <div className="col-12 mb-3">
                                <label className="form-label fw-semibold text-dark mb-1" style={{ fontSize: "12px" }}>
                                    Agenda <span className="text-danger">*</span>
                                </label>
                                <textarea
                                    className="form-control px-2 py-1 shadow-sm"
                                    rows="3"
                                    placeholder="Enter agenda"
                                    style={{ borderRadius: '8px', border: '1px solid #e2e8f0', color: '#475569', fontSize: "13px", resize: 'vertical', backgroundColor: '#f8fafc' }}
                                    {...register("agenda", {
                                        required: "This field is required",
                                    })}
                                ></textarea>
                                <ErrorMessage message={errors.agenda?.message} />
                            </div>
                            <div className="col-12">
                                <div className="form-group mb-2">
                                    <label htmlFor="Role" className="form-label fw-semibold text-dark mb-1" style={{ fontSize: "12px" }}>
                                        Assign Users
                                        <span className="text-danger">*</span>
                                    </label>
                                    <MultiSelectDropdown
                                        options={pageStates?.users || []}
                                        isLoading={pageStates.isLoadingUsers}
                                        placeholder='Search & Select Users...'
                                        selectedValues={pageStates?.selectedUsers}
                                        onChange={(values) => handleUserChange(values)}
                                        multiSelect={true}
                                        setPageStates={setPageStates}
                                        search={true}
                                        onSearch={(q) => GetUsersList(q)}
                                        showSelectAll={false}
                                        showUnSelectAll={false}
                                        emptyMessage="No Users Found"
                                    />
                                    {errors.attendees && <ErrorMessage message={errors.attendees?.message} />}
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group mb-0">
                                    <label htmlFor="Role" className="form-label fw-semibold text-dark mb-1" style={{ fontSize: "12px" }}>
                                        Sites
                                    </label>
                                    <MultiSelectDropdown
                                        options={pageStates?.sites || []}
                                        isLoading={pageStates.isLoadingSites}
                                        placeholder='Search & Select Sites...'
                                        selectedValues={pageStates?.selectedSites}
                                        onChange={(values) => handleSiteChange(values)}
                                        multiSelect={true}
                                        setPageStates={setPageStates}
                                        search={true}
                                        onSearch={(q) => GetSitesList(q)}
                                        showSelectAll={false}
                                        showUnSelectAll={false}
                                        emptyMessage="No Sites Found"
                                    />
                                    {errors.attendees && <ErrorMessage message={errors.attendees?.message} />}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="border-0 pt-0 pb-0 d-flex justify-content-end gap-3 mt-4">
                        <button
                            type="button"
                            className="btn btn-light border fw-semibold px-4 py-2 rounded-pill"
                            onClick={toggle}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="btn btn-primary fw-semibold px-4 py-2 rounded-pill shadow-sm"
                            disabled={pageStates.isLoadingSubmit}
                        >
                            {pageStates.isLoadingSubmit ? <Spinner size="sm" /> : selectedMeeting ? "Update Meeting" : "Create Meeting"}
                        </button>
                    </div>
                </form>
            </ModalBody>
        </Modal>
    );
};

export default CreateMeetingModal;
